import { AdData } from '@/types';

interface AdContext {
    assistantType: string;
    messageCount: number;
    userId?: string;
    sessionDuration?: number;
}

export class AdService {
    private static instance: AdService;
    private impressions: Map<string, number> = new Map();

    private constructor() {}

    static getInstance(): AdService {
        if (!AdService.instance) {
            AdService.instance = new AdService();
        }
        return AdService.instance;
    }

    getAd(context: AdContext): AdData | null {
        // Milestone ad every 10 messages
        if (context.messageCount > 0 && context.messageCount % 10 === 0) {
            return {
                id: `milestone-${Date.now()}`,
                type: 'banner',
                content: {
                    title: 'Enjoying the conversation?',
                    description: 'Remove ads with Pro • 50% off today',
                    cta: 'Go Pro',
                    advertiser: 'Advertisement',
                },
                targeting: {
                    assistantType: context.assistantType,
                    messageCount: context.messageCount,
                },
            };
        }

        // Assistant-specific ads
        if (context.messageCount > 5 && Math.random() > 0.7) {
            return this.getAssistantSpecificAd(context.assistantType);
        }

        return null;
    }

    private getAssistantSpecificAd(assistantType: string): AdData {
        const ads: Record<string, AdData> = {
            automotive: {
                id: `auto-${Date.now()}`,
                type: 'sponsored',
                content: {
                    title: 'AutoZone - Save on Car Parts',
                    description: 'Free next-day delivery on orders over $35',
                    cta: 'Shop Now',
                    advertiser: 'AutoZone',
                },
            },
            realestate: {
                id: `real-${Date.now()}`,
                type: 'sponsored',
                content: {
                    title: 'Zillow - Find Your Dream Home',
                    description: 'Browse millions of listings in your area',
                    cta: 'Search Homes',
                    advertiser: 'Zillow',
                },
            },
            wellness: {
                id: `well-${Date.now()}`,
                type: 'sponsored',
                content: {
                    title: 'Headspace - Meditation Made Simple',
                    description: 'Start your free trial today',
                    cta: 'Try Free',
                    advertiser: 'Headspace',
                },
            },
        };

        return ads[assistantType] || ads.automotive;
    }

    trackImpression(adId: string): void {
        const count = this.impressions.get(adId) || 0;
        this.impressions.set(adId, count + 1);

        // Send to analytics
        this.sendAnalytics('impression', adId);
    }

    trackClick(adId: string): void {
        this.sendAnalytics('click', adId);
    }

    private sendAnalytics(event: string, adId: string): void {
        // Implement analytics tracking
        console.log(`Ad ${event}:`, adId);

        // Example: Send to Google Analytics
        if (typeof window !== 'undefined' && (window as any).gtag) {
            (window as any).gtag('event', `ad_${event}`, {
                ad_id: adId,
                timestamp: Date.now(),
            });
        }
    }
}